import React from 'react';

const Input = ({label, className, ...props}) => {
    return (
        <div className={`text-left w-full ${className}`}>
            {label && <div className="text-sm text-ea_gray_dark mb-1 ">{label}</div>}
            <input className="p-2 bg-transparent border border-ea_gray w-full" {...props}/>
        </div>
    );
};

export default Input;